import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-alert-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  template: `
    <h2 mat-dialog-title class="flex items-center gap-2">
      <mat-icon [color]="data.color || 'warn'">{{ data.icon || 'error_outline' }}</mat-icon>
      {{ data.title || 'Alerta' }}
    </h2>
    <div mat-dialog-content>
      <p class="mb-2">{{ data.message || 'Ha ocurrido un problema.' }}</p>
      <p *ngIf="data.hint" class="text-sm text-gray-600">{{ data.hint }}</p>
    </div>
    <div mat-dialog-actions align="end">
      <button mat-stroked-button color="primary" (click)="close()">{{ data.okLabel || 'Entendido' }}</button>
    </div>
  `,
})
export class AlertDialogComponent {
  constructor(
    private ref: MatDialogRef<AlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title?: string; message?: string; hint?: string; icon?: string; color?: 'primary' | 'accent' | 'warn'; okLabel?: string }
  ) {}

  close() { this.ref.close(); }
}